<template>
    <div
        ref="banner"
        class="premium-i-b"
    >
        <div
            v-for="point in points"
            :key="`bg-${point.id}`"
            class="premium-i-b__ovf _mobile-hidden"
            :class="{
                [`premium-i-b__ovf-${point.id}`]: true,
                'premium-i-b__ovf_active': focusedPoint === point.id,
            }"
        />
        <div
            v-for="point in points"
            :key="`point-${point.id}`"
            class="premium-i-b__point _mobile-hidden"
            :style="{
                left: `${point.coordinates[0] * multiplier}px`,
                top: `${point.coordinates[1] * multiplier}px`,
            }"
            @pointerenter="focusedPoint = point.id"
            @pointerleave="focusedPoint = ''"
            @click="scrollToElem(point.anchor)"
        >
            <div
                class="premium-i-b__content _pt-16 _pb-16 _pl-40 _pr-40"
                :class="{
                    'premium-i-b__content_left': point.position === 'left',
                    'premium-i-b__content_active': focusedPoint === point.id,
                }"
            >
                <slot :name="`point-${point.id}`" />
            </div>
            <button
                class="premium-i-b__btn"
                type="button"
            >
                <div class="icon icon-premium-plus icon_size-16" />
            </button>
        </div>
    </div>
</template>
<script>
import { getRect } from '../../assets/js/vue/utlis/getRect';
import { useResize } from '../../assets/js/vue/utlis/useResize';
import { scrollToElem } from '../../assets/js/utils';
import { ref, toRefs } from 'vue';

export default {
    name: 'PremiumInteractiveBanner',
    setup(props) {
        const multiplier = ref(0);
        const banner = ref(null);
        const { containerWidthInitial } = toRefs(props);

        const setWidth = async () => {
            const bannerEl = banner.value;
            if (bannerEl) {
                const multiplierRaw = (await getRect(bannerEl)).width / containerWidthInitial.value;
                if (multiplier.value !== multiplierRaw) multiplier.value = multiplierRaw;
            }
        };

        useResize(setWidth, true);

        return {
            multiplier,
            banner,
        };
    },
    props: {
        containerWidthInitial: { type: Number, default: 1216 },
        points: {
            type: Array,
            default: () => [
                {
                    id: '1',
                    coordinates: [385, 326],
                    position: 'left',
                    anchor: 'premium-card-accordeon__0'
                },
                {
                    id: '2',
                    coordinates: [833, 393],
                    anchor: 'premium-card-accordeon__1'
                },
                {
                    id: '3',
                    coordinates: [928, 108],
                    anchor: 'premium-card-accordeon__2'
                },
            ],
        },
    },
    methods: {
        scrollToElem(elem) {
            scrollToElem(elem)
        }
    },
    data() {
        return {
            focusedPoint: '',
        };
    },
};
</script>
<style lang="scss">
@import './PremiumInteractiveBanner.scss';
</style>
